{
  "name": "@ns/recover-public-ledger-account-keys",
  "version": "1.0.0",
  "description": "A job to recover ledger account keys",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
